import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FilterGalleryOptions, GalleryApi } from 'api';

export const findGallery = createAsyncThunk(
  'gallery/findGallery',
  async (option: FilterGalleryOptions, { rejectWithValue }) => {
    try {
      const response = await GalleryApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createGallery = createAsyncThunk(
  'gallery/createGallery',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await GalleryApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateGallery = createAsyncThunk(
  'gallery/updateGallery',
  async (params: any, { rejectWithValue }) => {
    const { id, body } = params;
    try {
      const response = await GalleryApi.update(id, body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeGallery = createAsyncThunk(
  'gallery/removeGallery',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await GalleryApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: IState = {
  list: [],
  reloadFlag: true,
};

const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {
    reloadGallery(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findGallery.fulfilled, (state, action) => {
        const { data } = action.payload;
        const newData = data.map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      })
      .addCase(createGallery.fulfilled, (state, action) => {
        const { data } = action.payload;
        const { id, name, quantity, medias } = data;
        const galleryMedias = medias.map((item: any) => {
          return {
            media: {
              url: item.url,
            },
          };
        });
        const newData = {
          id,
          name,
          quantity,
          galleryMedias,
        };
        state.list = [newData].concat(state.list);
      })
      .addCase(removeGallery.fulfilled, (state, action) => {
        const { data } = action.payload;
        const { id } = data;
        const newList = state.list.filter(item => item.id !== id);
        state.list = newList;
      });
  },
});

const { actions, reducer: galleryReducer } = gallerySlice;

export const { reloadGallery } = actions;

export default galleryReducer;
